const AdministratorSearchPage = (): JSX.Element => <></>;

export default AdministratorSearchPage;
